export default __webpack_public_path__ + "static/media/wordpress.f39aa81e.svg";